const topSwiper = new Swiper('#shopify-section-template--22439366885670__item_slider_kobe_V9tWDy .top-swiper', {
    loop: true,
    speed: 500,
    slidesPerView: 'auto',
    centeredSlides : false,
    breakpoints: {
      768: {
        slidesPerView: 4,
      }
    },
    navigation: {
      nextEl: "#shopify-section-template--22439366885670__item_slider_kobe_V9tWDy .top-swiper-button-next",
      prevEl: "#shopify-section-template--22439366885670__item_slider_kobe_V9tWDy .top-swiper-button-prev",
    },
  });

const topSwiper2 = new Swiper('#shopify-section-template--22439366885670__item_slider_kobe_bA9Tqi .top-swiper', {
    loop: true,
    speed: 500,
    slidesPerView: 'auto',
    centeredSlides : false,
    breakpoints: {
      768: {
        slidesPerView: 4,
      }
    },
    navigation: {
      nextEl: "#shopify-section-template--22439366885670__item_slider_kobe_bA9Tqi .top-swiper-button-next",
      prevEl: "#shopify-section-template--22439366885670__item_slider_kobe_bA9Tqi .top-swiper-button-prev",
    },
  });